import { Outlet, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  Box,
  Grid,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
} from "@mui/material";
import "./CheckoutV2View.scss";
import { useSelector } from "react-redux";
import { orderType } from "../../utils/Constants";
import { useTranslation } from "react-i18next";

function CheckoutV2View(props: any) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => {
    return location.pathname === path ? "active" : "inactive";
  };
  const { cartInfo, selectedAddressInCart,tempCartPayLoad } = useSelector(
    (state: any) => state.cart
  );
  
  let pujaType = "";
  if (tempCartPayLoad?.orderType === orderType.puja) {
    pujaType = "Puja";
  } else if (tempCartPayLoad?.orderType === orderType.chadhava) {
    pujaType = "Chadhava";
  } else if (tempCartPayLoad?.orderType === orderType.prasad) {
    pujaType = "Prasad";
  }

  const steps = [
  pujaType === "Chadhava"
    ? "Chadhava_Selection"
    : pujaType === "Prasad"
    ? "Prasad_Selection"
    : "Puja Selection",
  "Add_Devotee_Details",
  "Review_Details_Checkout",
];

  return (
    <Box
      className="pageContainer PujaDetailsView"
      style={{ minHeight: "50em" }}
    >
      <Box className="PujaDetailsViewBlock">
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            className="d-none d-md-block"
          ></Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box className="addPujaTab">
              {cartInfo && cartInfo.length > 0 && (
                <Box
                  sx={{
                    width: "100%",
                    borderBottom: "4px solid #fff",
                    paddingBottom: "1rem",
                    marginBottom: "1rem",
                    marginTop: "0.2rem",
                  }}
                >
                  <Stepper
                    activeStep={props.getStepNumber()}
                    alternativeLabel
                    connector={
                      <StepConnector
                        sx={{
                          "& .MuiStepConnector-line": {
                            borderColor: "#d56939",
                            borderTopWidth: "2px",
                          },
                        }}
                      />
                    }
                  >
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel>{t(label)}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              )}
              {/* <PujaStepsView/> */}
              <Box className="tabsContents">
                <Outlet />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            className="d-none d-md-block"
          ></Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default CheckoutV2View;
